/* eslint-disable */
type RikClientConfig = {
  available: boolean
  api_url: string
  api_url_v2?: string
  document_url: string
  static_url: string
  productionTip: boolean
  devtools: boolean
  isProduction: boolean
  isLite?: boolean
}

let config: RikClientConfig = {
  available: false,
  api_url: '',
  document_url: 'https://document-editor.ukrik.com/',
  static_url: 'https://static.stage.ukrik.com/',
  productionTip: true,
  devtools: false,
  isProduction: true
}

const hostname = window && window.location && window.location.hostname
const getHostnameName = (hostname: string) => {
  if (hostname === 'localhost') return 'localhost'

  return hostname.split('.')[1]
}

let domainEnv = getHostnameName(hostname)

switch (domainEnv) {
  case null:
    config = {
      available: true,
      api_url: 'https://api.ukrik.com',
      document_url: 'https://document-editor.ukrik.com/',
      static_url: 'https://static.stage.ukrik.com/',
      productionTip: true,
      devtools: false,
      isProduction: false
    }
    break
  case 'dev':
    config = {
      available: true,
      api_url: 'https://api.dev.ukrik.com',
      document_url: 'https://document-editor.ukrik.com/',
      static_url: 'https://static.stage.ukrik.com/',
      productionTip: false,
      devtools: true,
      isProduction: false
    }
    break

  case 'v2':
    config = {
      available: true,
      api_url: 'https://gateway.stage.ukrik.com/v1',
      api_url_v2: 'https://gateway.stage.ukrik.com/v2',
      document_url: 'https://document-editor.ukrik.com/',
      static_url: 'https://static.stage.ukrik.com/',
      productionTip: false,
      devtools: true,
      isProduction: false
    }
    break
  // // lite
  // case 'localhost':
  //   domainEnv = 'stage-lite'

  //   config = {
  //     available: true,
  //     api_url: `https://gateway.${domainEnv}.ukrik.com/v2`,
  //     api_url_v2: `https://gateway.${domainEnv}.ukrik.com/v2`,
  //     document_url: `https://document-editor.${domainEnv}.ukrik.com/`,
  //     static_url: `https://static.${domainEnv}.ukrik.com/`,
  //     productionTip: false,
  //     devtools: true,
  //     isProduction: true,
  //     isLite: true,
  //   }
  //   break;
  // default
  case 'localhost':
    config = {
      available: true,
      api_url: 'https://gateway.stage.ukrik.com/v1',
      api_url_v2: 'https://gateway.stage.ukrik.com/v2',
      document_url: 'https://document-editor.ukrik.com/',
      static_url: 'https://static.stage.ukrik.com/',
      productionTip: false,
      devtools: true,
      // isProduction: false,
      isProduction: false,
      isLite: false,
    }
    break
  case 'prod':
    config = {
      available: true,
      api_url: 'https://gateway.prod.ukrik.com/v1',
      api_url_v2: 'https://gateway.prod.ukrik.com/v2',
      document_url: 'https://document-editor.prod.ukrik.com/',
      static_url: 'https://static.prod.ukrik.com/',
      productionTip: true,
      devtools: false,
      isProduction: true
    }
    break
  case 'test':
    config = {
      available: true,
      api_url: 'https://gateway.test.ukrik.com/v1',
      api_url_v2: 'https://gateway.test.ukrik.com/v2',
      document_url: 'https://document-editor.test.ukrik.com/',
      static_url: 'https://static.test.ukrik.com/',
      productionTip: true,
      devtools: false,
      isProduction: false
    }
    break
  case 'prod-v2':
    config = {
      available: true,
      api_url: 'https://gateway.prod-v2.ukrik.com/v1',
      api_url_v2: 'https://gateway.prod-v2.ukrik.com/v2',
      document_url: 'https://document-editor.prod-v2.ukrik.com/',
      static_url: 'https://static.prod-v2.ukrik.com/',
      productionTip: true,
      devtools: false,
      isProduction: true
    }
    break
  case 'pronto':
    config = {
      available: true,
      api_url: 'https://gateway.pronto.rikroot.ru/v1',
      api_url_v2: 'https://gateway.pronto.rikroot.ru/v2',
      document_url: 'https://document-editor.pronto.rikroot.ru/',
      static_url: 'https://static.pronto.rikroot.ru/',
      productionTip: true,
      devtools: false,
      isProduction: true
    }
    break
  case 'megapronto':
    config = {
      available: true,
      api_url: 'https://gateway.megapronto.rikroot.ru/v1',
      api_url_v2: 'https://gateway.megapronto.rikroot.ru/v2',
      document_url: 'https://document-editor.megapronto.rikroot.ru/',
      static_url: 'https://static.megapronto.rikroot.ru/',
      productionTip: true,
      devtools: false,
      isProduction: true
    }
    break
  default:
    config = {
      available: true,
      api_url: `https://gateway.stage.ukrik.com/v1`,
      api_url_v2: `https://gateway.stage.ukrik.com/v2`,
      document_url: `https://document-editor.stage.ukrik.com/`,
      static_url: `https://static.stage.ukrik.com/`,
      productionTip: true,
      devtools: false,
      isProduction: true
    }
    break
  // default:
  //   config = {
  //     available: true,
  //     api_url: `https://gateway.${domainEnv}.ukrik.com/v1`,
  //     api_url_v2: `https://gateway.${domainEnv}.ukrik.com/v2`,
  //     document_url: `https://document-editor.${domainEnv}.ukrik.com/`,
  //     static_url: `https://static.${domainEnv}.ukrik.com/`,
  //     productionTip: true,
  //     devtools: false,
  //     isProduction: true
  //   }
  //   break
}
export const ROOT_CONFIG = config
